import { Link } from "react-router-dom";

// Replaceable wordmark: swap the spans below for an <img> when the logo arrives.
export const Wordmark = ({ light = false }) => (
  <Link
    to="/"
    data-testid="brand-wordmark"
    className="group inline-flex flex-col items-start leading-none"
    aria-label="1001 Nights Orchestra — home"
  >
    <span className="font-mono text-[9px] tracking-[0.55em] text-amber-400/80 uppercase mb-1">
      Est. 1987 · Austin
    </span>
    <span
      className={`font-serif text-lg sm:text-xl tracking-[0.18em] uppercase transition-shadow duration-500 ${
        light ? "text-amber-50" : "gold-text"
      } group-hover:drop-shadow-[0_0_18px_rgba(212,175,55,0.35)]`}
    >
      1001 Nights Orchestra
    </span>
  </Link>
);
